var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifeStyleHobby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97,
    height: 35,
    viewBox: "0 0 97 35",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lifeStyleHobby-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 35,
    transform: "translate(-19.896 1)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lifeStyleHobby",
    transform: "translate(19.896 -1)",
    clipPath: "url(#lifeStyleHobby-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.813,14.5l-13.2,15.4H18.2L25.9,14.5Z",
    transform: "translate(-6.179 -4.8)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.156,2c1.1,1.1,1.118,1.1,6.6,1.1a118.02,118.02,0,0,0,5.5,21.993",
    transform: "translate(-19.22)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.555,6.236,36.821,26.726",
    transform: "translate(-9.389 -1.627)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.893,4.429c0,.784-1.226,1.5-4.042,1.5-2.924,0-5.859,2.953-5.859-.569,0-1.02.226-1.568,1.484-1.568h7.1C29.356,3.8,29.893,3.817,29.893,4.429Z",
    transform: "translate(-6.869 -0.689)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.015,43.227a9.9,9.9,0,1,0-9.912-9.9A9.906,9.906,0,0,0,12.015,43.227Z",
    transform: "translate(0 -8.227)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.629,43.227a9.9,9.9,0,1,0-9.912-9.9A9.906,9.906,0,0,0,65.629,43.227Z",
    transform: "translate(-20.588 -8.227)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeStyleHobby);
export default __webpack_public_path__ + "static/media/lifeStyleHobby.3799b74032550f867e2e477e46a1a476.svg";
export { ForwardRef as ReactComponent };